/**
 * 🧱 Refactor BT Phase 3 — Étape 2 : section « SectionClientDossier » d'EditerBonTravailDialog.jsx.
 * JSX déplacé TEL QUEL (ex-L967-1027, dédenté de 10) ; variables lues via `useBTForm()`
 * (BTFormProvider enrichi par `extra` dans le composant parent). DOM, data-testid, classes, textes inchangés.
 */
import { Building2, Mail, MapPin, Phone, User } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { GoogleMapsBtn } from '@/components/GoogleMapsBtn';
import { useBTForm } from '../../BTFormContext';

export function SectionClientDossier() {
  const {
    clientInfo,
    dossier,
  } = useBTForm();
  return (
    <>
      {/* Informations Client & Dossier */}
      <Card className="bg-gradient-to-r from-slate-50 to-gray-50 border-slate-200">
        <CardContent className="py-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Infos Client */}
            <div>
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-1">
                <User className="w-3.5 h-3.5" /> Informations Client
              </h3>
              <div className="space-y-1.5">
                <p className="font-semibold text-gray-900">{dossier?.client_nom || 'Client non défini'}</p>
                {clientInfo?.telephone && (
                  <p className="text-sm text-gray-600 flex items-center gap-1.5">
                    <Phone className="w-3.5 h-3.5 text-gray-400" />
                    {clientInfo.telephone}
                  </p>
                )}
                {clientInfo?.email && (
                  <p className="text-sm text-gray-600 flex items-center gap-1.5">
                    <Mail className="w-3.5 h-3.5 text-gray-400" />
                    {clientInfo.email}
                  </p>
                )}
                {clientInfo?.adresse_client && (
                  <p className="text-sm text-gray-600 flex items-center gap-1.5 flex-wrap">
                    <MapPin className="w-3.5 h-3.5 text-gray-400 shrink-0" />
                    <span>{clientInfo.adresse_client}, {clientInfo.ville_client} {clientInfo.code_postal_client}</span>
                    <GoogleMapsBtn address={clientInfo.adresse_client} ville={clientInfo.ville_client} codePostal={clientInfo.code_postal_client} />
                  </p>
                )}
              </div>
            </div>

            {/* Infos Dossier */}
            <div>
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-1">
                <Building2 className="w-3.5 h-3.5" /> Informations Projet
              </h3>
              <div className="space-y-1.5">
                <p className="font-semibold text-gray-900">{dossier?.nom_dossier || 'Projet non défini'}</p>
                <p className="text-sm text-gray-600">
                  <span className="text-gray-500">N° Dossier:</span> {dossier?.numero_dossier || '-'}
                </p>
                {dossier?.adresse_travaux && (
                  <p className="text-sm text-gray-600 flex items-center gap-1.5 flex-wrap">
                    <MapPin className="w-3.5 h-3.5 text-gray-400 shrink-0" />
                    <span>{dossier.adresse_travaux}, {dossier.ville_travaux} {dossier.code_postal_travaux}</span>
                    <GoogleMapsBtn address={dossier.adresse_travaux} ville={dossier.ville_travaux} codePostal={dossier.code_postal_travaux} />
                  </p>
                )}
                {dossier?.representant_nom && (
                  <p className="text-sm text-gray-600">
                    <span className="text-gray-500">Représentant:</span> {dossier.representant_nom}
                  </p>
                )}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

    </>
  );
}
